<template>
  <div>
    <BulkOpsHeader
      @new="newDialog = true"
    >
      Case Bulk Operations
      <div
        v-if="casetype"
        style="font-size: 0.9em; margin-top: 5px;"
      >
        {{casetype.name}}
      </div>
    </BulkOpsHeader>
    <BulkOpsTable
      :rows.sync="caseTypeOps"
      :headers="headers"
      :totalRows="pagination.totalRows"
      :pagination="pagination"
      :loading="loading"
      @fetch="pagination=arguments[0]"
    >
      <template v-slot:default="prop">
        <td>
          {{prop.row.count}}
        </td>
        <td>
          <div
            v-if="typeof JSON.parse(prop.row.update_json).set_active !== 'undefined'"
          >
            <b>{{JSON.parse(prop.row.update_json).set_active ? 'Open Cases' : 'Close Cases'}}</b>
          </div>
          <div
            v-if="JSON.parse(prop.row.update_json).retype"
          >
            <b>Update Case Type of Case(s)</b>
          </div>
          <div
            v-if="JSON.parse(prop.row.update_json).checklist"
          >
            <b>Update Case Checklist - </b>
            {{ 
              (() => {
                const checklistId = JSON.parse(prop.row.update_json).checklist
                const item = casetype && casetype.checklist_items
                  ? casetype.checklist_items.find(ci => ci.id === checklistId)
                  : null
                return item ? item.title : 'Unknown Item (Deleted?)'
              })()
            }}
            - {{ JSON.parse(prop.row.update_json).checklist_value ? 'Checked' : 'Unchecked' }}
          </div>
        </td>
        <td style="text-transform: capitalize;">
          {{prop.row.status}}
        </td>
      </template>
    </BulkOpsTable>
    <BulkOpsDialog
      v-if="newDialog"
      title="New Bulk Case Update Operation"
      :update_actions="bulkOpActions"
      :update_placeholder="'Case Numbers to Update (one per line)'"
      :digit_rule="false"
      :case_type="casetype"
      @save="save(arguments[0])"
      @cancel="newDialog = false"
    />
  </div>
</template>

<script>
import api from '@/api'
import moment from 'moment'
import GlobalConstants from '@/globals'
import pagination from '@/components/global/pagination'
import BulkOpsHeader from '@/components/admin/bulkops/BulkOpsHeader'
import BulkOpsTable from '@/components/admin/bulkops/BulkOpsTable'
import BulkOpsDialog from '@/components/admin/bulkops/BulkOpsDialog'

export default {
  name: 'CaseTypeBulkOps',
  components: {
    BulkOpsHeader,
    BulkOpsTable,
    BulkOpsDialog
  },
  mixins: [
    pagination
  ],
  data () {
    return {
      caseTypeOps: [],
      casetype: null,
      loading: false,
      pagination: {},
      totalRows: null,
      pages: null,
      newDialog: false,
      interval: null,
      headers: [
        { text: 'Count', width: 20, sortable: false },
        { text: 'Action', width: 180, sortable: false },
        { text: 'Status', width: 60, sortable: false },
        { text: 'Run Time', width: 60, sortable: false },
        { text: 'Progress', width: 60, sortable: false },
      ],
      bulkOpActions: [
        {
          "title": "Set Open / Closed",
          "prop": "set_active",
          "type": "dropdown",
          "options": [
            {
              "name": "Open",
              "value": true
            },
            {
              "name": "Closed",
              "value": false
            }
          ],
          "value": null,
          "hint": "Closed cases are hidden from Contacts and from most search results by default."
        },
        {
          "title": "Update Case Type (Administrator Only)",
          "prop": "set_case",
          "type": "checkbox",
          "guard": "admin",
          "value": null,
          "hint": "Update the Case Type of the selected Cases"
        },
        {
          "title": "Case Type",
          "prop": "retype",
          "type": "selection",
          "type_scope": "casetypes",
          "value": null,
          "hint": "Case Type to set on the selected Cases",
          "required": true,
          "prereq": "set_case",
        },
        {
          "title": "Update Case Checklist Values",
          "prop": "set_checklist",
          "type": "checkbox",
          "value": null,
          "hint": "Update the Case Checklist values of the selected Cases"
        },
        {
          "title": "Checklist Item",
          "prop": "checklist",
          "type": "selection",
          "type_scope": "checklist",
          "value": null,
          "hint": "The checklist item to update",
          "required": true,
          "prereq": "set_checklist",
        },
        {
          "title": "Set Check Value",
          "prop": "checklist_value",
          "type": "dropdown",
          "options": [
            {
              "name": "Checked",
              "value": true
            },
            {
              "name": "Unchecked",
              "value": false
            }
          ],
          "value": null,
          "hint": "What value to set the selected checklist item to",
          "required": true,
          "prereq": "set_checklist",
        },
      ]
    }
  },
  created () {
    this.documentTitle('Case Bulk Operations')
  },
  methods: {
    restartInterval () {
      clearInterval(this.interval)
      var countWorking = 0
      this.caseTypeOps.forEach((item) => {
        if (["finished", "failed"].indexOf(item.status) == -1)
          countWorking++
      })
      if (countWorking > 0) {
        this.interval = setInterval(() => {
          this.fetch()
        }, 5000)
      }
    },
    fetch () {
      this.loading = true
      var caseTypePromise = this.casetype == null ? api.cases.casetype.get(this.$route.params.id) : Promise.resolve(this.casetype)
      
      caseTypePromise.then((data) => {
          this.documentTitle(`Case Bulk Operations - ${data.name}`)
          this.casetype = data
          this.componentCreated = true
        })
        .finally(() => {
          api.bulkops.cases.list({
            pageNum: this.pagination.page, count: this.pagination.rowsPerPage, ordering: '-created_at', filter: {'case_type__id': this.$route.params.id}
          })
            .then(data => {
              this.caseTypeOps = data.results
              this.pagination.totalRows = data.count
              this.pagination.page = data.page_number
              this.loading = false
              this.componentCreated = true
              this.restartInterval()
            })
        })
    },
    save (newOp) {
      var case_numbers = []
      var update_json = {}
      newOp.update.split(/\r?\n/).forEach((case_number) => {
        if (case_number !== "") {
          case_numbers.push(case_number)
        }
      })
      newOp.props.forEach((prop) => {
        if (prop.value !== null && prop.value !== "") {
          update_json[prop.prop] = prop.value
        }
        if (prop.prop == "retype" && prop.value !== null) {
          update_json[prop.prop] = prop.value.value
        }
        if (prop.prop == "checklist" && prop.value !== null) {
          update_json[prop.prop] = prop.value.value
        }
      })
      api.bulkops.cases.save({case_numbers: JSON.stringify(case_numbers),
                                 update_json: JSON.stringify(update_json), case_type: this.$route.params.id})
      .then(() => {
        this.newDialog = false
        this.fetch()
      })
    }
  },
  beforeDestroy () {
    clearInterval(this.interval)
  }
}
</script>
